module.exports = __webpack_public_path__ + "images/花筑般蓝pr长图_08.jpg?v=bdadda9d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu3/花筑般蓝pr长图_08.jpg
 ** module id = 65
 ** module chunks = 1 2
 **/